// Valvella theme — shared site behavior
// Scroll reveal, mobile nav, predictive search, product card sliders, cart count sync.

(function () {

  // ---- Scroll reveal ----
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('is-visible'); });
    }, { threshold: 0.15 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  // ---- Mobile nav toggle ----
  document.querySelectorAll('[data-nav-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = document.querySelector('[data-nav-left]');
      if (nav) nav.classList.toggle('open');
    });
  });

  // ---- Cart count ----
  window.ValvellaCart = {
    refresh: function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        });
    },
    add: function (variantId, quantity, onDone, onError) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) { if (onError) onError(result.data); return; }
          window.ValvellaCart.refresh();
          if (onDone) onDone(result.data);
        })
        .catch(function (err) { if (onError) onError(err); });
    }
  };

  // ---- Quick add to bag (product cards) ----
  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      var original = btn.textContent;
      btn.textContent = 'Adding…';
      window.ValvellaCart.add(variantId, 1, function () {
        btn.textContent = 'Added ✓';
        setTimeout(function () { btn.textContent = original; }, 1500);
      }, function () {
        btn.textContent = 'Sold out';
        setTimeout(function () { btn.textContent = original; }, 1500);
      });
    });
  });

  // ---- Predictive search ----
  (function () {
    var toggle = document.getElementById('searchToggle');
    var overlay = document.getElementById('searchOverlay');
    var input = document.getElementById('searchInput');
    var results = document.getElementById('searchResults');
    var closeBtn = document.getElementById('searchClose');
    if (!toggle || !overlay) return;

    var debounceTimer;

    function renderResults(items, query) {
      if (!items || items.length === 0) {
        results.innerHTML = '<p class="search-empty">No dresses match “' + query + '”.</p>';
        return;
      }
      results.innerHTML = items.map(function (p) {
        return '<a class="search-result" href="' + p.url + '"><span>' + p.title + '</span><span class="price">' + p.price + '</span></a>';
      }).join('');
    }

    function search(query) {
      var q = query.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderResults(products.map(function (p) {
            return { title: p.title, url: p.url, price: p.price };
          }), q);
        });
    }

    function openSearch() {
      overlay.classList.add('open');
      input.value = '';
      results.innerHTML = '';
      setTimeout(function () { input.focus(); }, 10);
    }
    function closeSearch() { overlay.classList.remove('open'); }

    toggle.addEventListener('click', function (e) { e.preventDefault(); openSearch(); });
    closeBtn.addEventListener('click', closeSearch);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeSearch(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSearch(); });
    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var val = input.value;
      debounceTimer = setTimeout(function () { search(val); }, 200);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        var first = results.querySelector('.search-result');
        if (first) window.location.href = first.getAttribute('href');
      }
    });
  })();

  // ---- Product image sliders (product cards + PDP) ----
  document.querySelectorAll('[data-slider]').forEach(function (slider) {
    var slides = slider.querySelectorAll('.slide');
    var dots = slider.querySelectorAll('.slider-dot');
    var index = 0;
    function show(i) {
      slides.forEach(function (s, idx) { s.classList.toggle('active', idx === i); });
      dots.forEach(function (d, idx) { d.classList.toggle('active', idx === i); });
      index = i;
    }
    var prev = slider.querySelector('.slider-arrow.prev');
    var next = slider.querySelector('.slider-arrow.next');
    if (prev) prev.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      show((index - 1 + slides.length) % slides.length);
    });
    if (next) next.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      show((index + 1) % slides.length);
    });
    dots.forEach(function (d, idx) {
      d.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        show(idx);
      });
    });
    var startX = null;
    slider.addEventListener('pointerdown', function (e) { startX = e.clientX; });
    slider.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var diff = e.clientX - startX;
      if (Math.abs(diff) > 30) {
        show(diff < 0 ? (index + 1) % slides.length : (index - 1 + slides.length) % slides.length);
        var link = slider.closest('a');
        if (link) {
          var suppress = function (ev) { ev.preventDefault(); ev.stopPropagation(); link.removeEventListener('click', suppress, true); };
          link.addEventListener('click', suppress, true);
        }
      }
      startX = null;
    });
  });

})();